import React, { useState } from 'react';

import { TextField } from '@mui/material';
import { Form, Formik } from 'formik';
import * as Yup from 'yup';

import { clinicalEmailSignUp } from '../functions/Klaviyo';

import ModalWithChildren from './ModalWithChildren';
import { Button } from './web';

type FooterModalProps = {
  onClose: () => void;
  onSuccess?: () => void;
};

const FooterModal = (props: FooterModalProps) => {
  const [thankYou, setThankYou] = useState('');

  const validate = Yup.object({
    email: Yup.string()
      .email('Please enter a valid email address')
      .required('Email is required'),
  });

  return (
    <ModalWithChildren onClose={() => props.onClose()}>
      <div className={classNames.modal.container}>
        {thankYou ? (
          <h2 className={classNames.modal.title}>{thankYou}</h2>
        ) : (
          <>
            <h2 className={classNames.modal.title}>Join our newsletter</h2>
            <h4 className={classNames.modal.subtitle}>
              Stay informed with the latest advancements in fertility care
            </h4>
            <Formik
              initialValues={{
                email: '',
              }}
              validationSchema={validate}
              onSubmit={(values, { resetForm }) => {
                const input = {
                  ...values,
                };
                clinicalEmailSignUp(input, (val: boolean) => {
                  if (val) {
                    setThankYou('Thank you for subscribing to our newsletter!');
                    resetForm();
                    props.onSuccess?.();
                  } else {
                    setThankYou(
                      'There was an issue with subscribing please try again.',
                    );
                  }
                });
              }}
            >
              {(formik) => (
                <Form className={classNames.modal.form}>
                  <TextField
                    placeholder="Enter your email"
                    name="email"
                    type="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    autoFocus
                  />
                  <Button preset="fab" text="Sign up" type="submit" />
                </Form>
              )}
            </Formik>
          </>
        )}
      </div>
    </ModalWithChildren>
  );
};

const classNames = {
  modal: {
    container: [
      'tw-flex',
      'tw-flex-col',
      'tw-mx-[24px]',
      'tw-gap-[16px]',
      'tw-mb-[56px]',
      'tw-justify-center',
      'tw-min-h-[224px]',
    ].join(' '),
    title: ['tw-h1', 'tw-text-center'].join(' '),
    subtitle: ['tw-body1', 'tw-text-center'].join(' '),
    form: [
      'tw-flex',
      'tw-flex-col',
      'tw-gap-[32px]',
      'tw-items-center',
      'md:tw-mx-[85px]',
    ].join(' '),
  },
};

export { FooterModal };
